import { render } from "./PRO_Produse.vue?vue&type=template&id=62655a27&scoped=true&ts=true"
import script from "./PRO_Produse.vue?vue&type=script&lang=ts"
export * from "./PRO_Produse.vue?vue&type=script&lang=ts"

import "./PRO_Produse.vue?vue&type=style&index=0&id=62655a27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62655a27"]])

export default __exports__